import React from "react";
import { motion } from "framer-motion";

const pageVariants = {
  initial: {
    opacity: 0,
    // x: "-100vw",
  },
  in: {
    opacity: 1,
    // x: 0,
  },
  out: {
    opacity: 0,
    // x: "100vw",
  },
};

const pageTransition = {
  // type: "tween",
  ease: "easeIn",
  duration: 0.3,
};

const pageStyle = {
  position: "relative",
};

export default function WithMotion(Component) {
  // eslint-disable-next-line react/display-name
  return (props) => (
    <motion.div
      style={pageStyle}
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Component {...props} />
    </motion.div>
  )
}
